import { IconProps } from "./types";
import { SVGIcon } from "./svg-icon";

export const User = ({
  size,
  type,
  theme,
  className,
  dataTestId = "user-icon",
}: IconProps) => (
  <SVGIcon
    size={size}
    type={type}
    theme={theme}
    className={className}
    dataTestId={dataTestId}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.86219 10.5064C6.52513 9.07995 9.72508 9.07995 12.388 10.5064C13.3292 11.0106 13.9167 11.9918 13.9167 13.0595L13.9167 15.0007C13.9167 15.3688 13.6182 15.6673 13.25 15.6673H3.00016C2.82335 15.6673 2.65378 15.5971 2.52876 15.4721C2.40373 15.347 2.33349 15.1775 2.3335 15.0006L2.33351 13.0595C2.33352 11.9918 2.92099 11.0106 3.86219 10.5064ZM11.7584 11.6818C9.48878 10.466 6.76143 10.466 4.49179 11.6818C3.98387 11.9538 3.66685 12.4833 3.66684 13.0595L3.66683 14.334H12.5834L12.5834 13.0595C12.5834 12.4833 12.2663 11.9538 11.7584 11.6818Z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.00016 6.66667C9.19678 6.66667 10.1668 5.69662 10.1668 4.5C10.1668 3.30338 9.19678 2.33333 8.00016 2.33333C6.80355 2.33333 5.8335 3.30338 5.8335 4.5C5.8335 5.69662 6.80355 6.66667 8.00016 6.66667ZM8.00016 8C9.93316 8 11.5002 6.433 11.5002 4.5C11.5002 2.567 9.93316 1 8.00016 1C6.06717 1 4.50016 2.567 4.50016 4.5C4.50016 6.433 6.06717 8 8.00016 8Z"
    />
  </SVGIcon>
);
